import { render, staticRenderFns } from "./modal-center.vue?vue&type=template&id=e0ad1ec4&scoped=true"
import script from "./modal-center.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-center.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-center.vue?vue&type=style&index=0&id=e0ad1ec4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ad1ec4",
  null
  
)

export default component.exports